export enum BuilderAnalysisClass {
  STATUTE_IDENTITY = -1,
  BOOLEAN_FLAG = -2,
  NUMERIC_THRESHOLD = -3,
}
